module.exports = __webpack_public_path__ + "static/media/github-icon-2.b2ffb3a3.png";